import { render, staticRenderFns } from "./Individual-coporation-modal.vue?vue&type=template&id=4061768f&"
import script from "./Individual-coporation-modal.vue?vue&type=script&lang=js&"
export * from "./Individual-coporation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports